// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3ee6d68a","455":"8d41bd66","977":"4650d3b9"}[chunkId] + ".chunk.js";
};